export const removeMinorAttributes = <
  Item extends { brand: string; brandModel: string; productionMethod: string },
>(
  item: Item,
) => ({
  ...item,
  brand: '',
  brandModel: '',
  linkedProductionMethods: [],
})
